import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

interface Criterion { id: string; label: string; passed: boolean; evidence: string }
type Snapshot =
  | { configured: false }
  | { configured: true; era: number; eraName: string; updatedAt: string; criteria: Criterion[] };

const PIXEL = '"Press Start 2P", monospace';
const MONO = '"JetBrains Mono", monospace';

/** Public page: the founder's own live gate. Data from GET /api/proof (public, cached 5 min). */
export default function ProofPage() {
  const [snap, setSnap] = useState<Snapshot | null>(null);
  useEffect(() => {
    let alive = true;
    fetch('/api/proof')
      .then((r) => r.json() as Promise<Snapshot>)
      .then((s) => { if (alive) setSnap(s); })
      .catch(() => { if (alive) setSnap({ configured: false }); });
    return () => { alive = false; };
  }, []);

  return (
    <main style={{ minHeight: '100vh', background: '#0a120d', color: '#f2ecdc', fontFamily: MONO, padding: '48px 24px', maxWidth: 820, margin: '0 auto' }}>
      <Link to="/" style={{ color: '#39ff14', fontFamily: PIXEL, fontSize: 10 }}>← FOUNDR-XI</Link>
      <h1 style={{ fontFamily: PIXEL, fontSize: 'clamp(14px, 3vw, 24px)', lineHeight: 1.5, margin: '32px 0 8px' }}>THE FOUNDER&rsquo;S OWN GATE. LIVE.</h1>
      <p style={{ color: '#a6b4aa', marginBottom: 32 }}>
        FOUNDR-XI is built inside FOUNDR-XI. This is the deterministic check its own bunker has to pass right now — the same check every founder faces. Red means the founder is blocked too.
      </p>
      {snap === null && <p>loading…</p>}
      {snap?.configured === false && <p>The founder&rsquo;s gate is not published yet.</p>}
      {snap?.configured && (
        <section>
          <h2 style={{ fontFamily: PIXEL, fontSize: 12, color: '#39ff14', marginBottom: 16 }}>
            ERA {String(snap.era + 1).padStart(2, '0')} — {snap.eraName.toUpperCase()}
          </h2>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {snap.criteria.map((c) => (
              <li key={c.id} style={{ display: 'grid', gridTemplateColumns: '24px 1fr', gap: 12, padding: '10px 0', borderBottom: '1px solid #1d2b22' }}>
                <span style={{ color: c.passed ? '#39ff14' : '#ff5c5c' }}>{c.passed ? '✓' : '✗'}</span>
                <span>
                  <span>{c.label}</span>
                  <br />
                  <span style={{ color: '#7d8a80', fontSize: 13 }}>{c.evidence}</span>
                </span>
              </li>
            ))}
          </ul>
          <p style={{ color: '#7d8a80', fontSize: 12, marginTop: 24 }}>Checked {new Date(snap.updatedAt).toLocaleString()} · refreshes every 5 minutes</p>
        </section>
      )}
    </main>
  );
}
